import React from 'react';
import { MailIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-ink" data-id="element-102" data-mp="3geze367ujv27">
      <div className="mx-auto max-w-content px-5 pb-32 pt-14 text-center sm:px-8" data-id="element-103" data-mp="3ggaohovss12a">
        <p className="text-sm font-bold uppercase tracking-[0.28em] text-accent" data-id="element-104" data-mp="32onk11rpbm8f">
          Órbita Digital™
        </p>
        <p className="mx-auto mt-4 max-w-md text-[15px] leading-relaxed text-muted" data-id="element-105" data-mp="36q953aee36tp">
          El sistema de reconexión N°1 para padres de adolescentes en Argentina. Porque recuperar el
          vínculo no debería costar todos tus fines de semana.
        </p>

        <ul className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center sm:gap-8" data-id="element-106" data-mp="3lelyq0q08dl1">
          <li data-id="element-107" data-mp="3qcxawi3rv06f">
            <a href="mailto:soporte.orbitdigital@gmail.com" className="inline-flex items-center gap-2 text-sm text-muted transition-colors duration-150 ease-soft hover:text-accent" data-id="element-108" data-mp="3qcnhekjiqavz">
              <MailIcon aria-hidden="true" className="h-4 w-4" data-id="element-109" data-mp="2eyt76k7dtxo6" />
              soporte.orbitdigital@gmail.com
            </a>
          </li>
          <li data-id="element-110" data-mp="3la29euiur3v8">
            <a href="https://www.orbitdigital.store" className="inline-flex items-center gap-2 text-sm text-muted transition-colors duration-150 ease-soft hover:text-accent" data-id="element-111" data-mp="3lbmt1p3mp2eb">
              <GlobeIcon aria-hidden="true" className="h-4 w-4" data-id="element-112" data-mp="3v8hq03k96uqh" />
              www.orbitdigital.store
            </a>
          </li>
        </ul>

        <p className="mx-auto mt-12 max-w-xl border-t border-line pt-8 text-base font-bold tracking-tight text-ivory sm:text-lg" data-id="element-113" data-mp="830k9lv0mb22">
          “El próximo conflicto puede ser diferente.”
        </p>

        <p className="mx-auto mt-6 max-w-xl text-xs leading-relaxed text-muted" data-id="element-114" data-mp="hstuojjf8k4q">
          © Órbita Digital 2026 — Todos los derechos reservados. Prohibida la reproducción y
          redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}